/**
 * Where a public-form lead stands, and how many the trainer has not opened — read by the leads
 * inbox (`pages/public-form-leads`) and by the roster's „Zgłoszenia" button (`pages/client-roster`).
 * Moved here from the inbox's model on 28 September 2026, when the count left the navigation for
 * the roster's head. No React, no DOM, no query hook.
 */

import type { TrainWithMeModulesPublicFormsDtosResponsesPublicFormLeadSummary as LeadSummary } from '~/shared/api/generated/model';

export type LeadStatus = 'new' | 'viewed' | 'converted' | 'other';

/**
 * Where a lead stands. The wire says `submitted` or `converted` (lower case); a submitted lead the
 * trainer has opened carries `viewedAt`, and that is the whole difference between new and viewed.
 */
export function leadStatusOf(lead: Pick<LeadSummary, 'status' | 'viewedAt'>): LeadStatus {
  switch ((lead.status ?? '').toLowerCase()) {
    case 'submitted':
      return lead.viewedAt == null ? 'new' : 'viewed';
    case 'converted':
      return 'converted';
    default:
      return 'other';
  }
}

/** How many leads the trainer has not opened yet — the navigation's badge. */
export function newLeadCount(leads: readonly LeadSummary[]): number {
  return leads.filter((lead) => leadStatusOf(lead) === 'new').length;
}
